import styled from 'styled-components';
import { ITheme } from '../../../../../../../styles/theme';

interface CustomCellProps {
  theme: ITheme;
  hasChange?: boolean;
  borderColor: string;
}

export const Row = styled.tr<CustomCellProps>`
  display: grid;
  grid-template-columns: 5fr 2fr 2fr;
  height: 64px;
  margin-bottom: 1rem;
  border-radius: 8px;
  ${({ theme, borderColor }: CustomCellProps) => `
    background: ${theme.colors.neutral.primary[0]};
     box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
     border: 2px solid ${borderColor};
  `}
`;

export const Cell = styled.td`
  align-self: center;
  padding-left: 1rem;
`;
